import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import CustomCategory from "../../../model/packageDelivery/customCategory/CustomCategory";
import { CustomCategoryService } from "../../../service/packageDelivery/customCategory/CustomCategoryService";


class CustomCategoryMultiSelectStore {

    public loading: boolean;
    public commonStore: CommonStore;
    public filter?: string;
    public elements: CustomCategory[];
    public selectedCustomCategories: CustomCategory[];
    public isSearchDialogOpen: boolean;

    constructor(commonStore: CommonStore, selectedCustomCategories?: CustomCategory[]) {
        this.loading = false;
        this.commonStore = commonStore;
        this.elements = [];
        this.selectedCustomCategories = selectedCustomCategories ?
            [...selectedCustomCategories] : [];
        this.isSearchDialogOpen = false;
        makeAutoObservable(this);
    }

    @action
    public async search(): Promise<void> {
        this.loading = true;
        const response = await CustomCategoryService.get(1, 30, this.filter);
        if (response.success) {
            runInAction(() => {
                this.elements = response.data?.data || [];
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public toggleSearchDialog(value?: boolean) {
        value = (value === undefined) ? !this.isSearchDialogOpen : value;
        this.isSearchDialogOpen = value;
        if (this.isSearchDialogOpen) {
            this.search();
        }
    }

    @action
    setSelectedCustomCategories(customCategories: CustomCategory[]): void {
        this.selectedCustomCategories = [...customCategories];
    }

    get isEmpty(): boolean {
        return this.elements.length === 0;
    }

    @action
    public async setFilter(filter: string) {
        this.filter = filter;
        await this.search();
    }

    @action
    public async setSelectedCustomCategory(customCategory: CustomCategory) {
        if (this.selectedCustomCategories?.findIndex(t => t.id === customCategory?.id) >= 0) {
            this.selectedCustomCategories = this.selectedCustomCategories.filter(t => t.id !== customCategory?.id);
        } else {
            this.selectedCustomCategories.push({ ...customCategory });
        }
    }

    @action
    public async clearSelection() {
        this.selectedCustomCategories = [];
    }

}

export default CustomCategoryMultiSelectStore;